const de = {
  title: 'Deaktivieren von Stellenangeboten',
  steps: {
    jobOfferings: 'Stellenangebote',
    jobPeriods: 'Zeiträume',
    verify: 'Überprüfen'
  },
  jobPeriods: {
    activeJobPeriod: 'Aktiver Zeitraum',
    inactiveJobPeriod: 'Inaktiver Zeitraum',
    selectAll: 'Alle Zeiträume auswählen'
  },
  warning: {
    title: 'Wichtig',
    information: 'Der bereits gestartete Zeitraum wird trotzdem voll abgerechnet.'
  },
  deactivateJobPeriods: {
    success: 'Die Zeiträume des Stellenangebots wurden erfolgreich deaktiviert.',
    failed: 'Die Zeiträume des Stellenangebots konnten nicht deaktiviert werden.'
  },
  button: 'Deaktivieren',
  tooltip: 'Aktuell gibt es keinen Zeitraum der deaktiviert werden könnte.',
  noJobOfferSelected: 'Kein Stellenangebot ausgewählt',
  noJobPeriodSelected: 'Kein Zeitraum ausgewählt',
  noPeriodsAvailable: 'Keine Zeiträume zum Deaktivieren verfügbar'
};

export default de;
export type DeactivateJobOffersTranslation = typeof de;
